import { Navigate } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const VendorStaffOnly = ({ component: Component, ...props }) => {
  const { isVendorStaff } = useAuth();

  if (!isVendorStaff) return <Navigate to="/app/crm" replace />;

  return <Component {...props} />;
};

export default VendorStaffOnly;

 